import { GetterTree } from 'vuex'

import { RootState } from '@/store/types'

import { DefinitionsState, Service } from './types'

export default <GetterTree<DefinitionsState, RootState>>{
  genders: state => state.genders,

  services: state => state.services,

  activeServices: (_, { services }: { services: Service[] }) =>
    services.map(service => ({
      ...service,
      subservices: service.subservices.filter(
        subService => subService.is_active,
      ),
    })),

  subServicesMap: (_, { services }: { services: Service[] }) =>
    services
      .flatMap(service => service.subservices)
      .reduce(
        (serviceAccum, service) => ({
          ...serviceAccum,
          [service.id]: { ...service },
        }),
        {},
      ),

  rejectReasons: state => state.rejectReasons,

  carePlans: state => state.carePlans,

  activeCarePlans: state =>
    state.carePlans.filter(carePlan => carePlan.is_available_for_booking),

  insuranceCompanies: state => state.insuranceCompanies,
}
